import React, { Fragment } from 'react';
import { FunnelMetrics, FunnelStep } from '../../types/throughput';
import { Card, CardHeader, CardTitle } from '../ui/Card';
import { ChevronRight } from 'lucide-react';
interface ThroughputFunnelProps {
  metrics: FunnelMetrics[];
}
const KEY_STEPS: FunnelStep[] = ['Created', 'Converted', 'Submitted to UW', 'Closing Scheduled', 'Funded'];
const STEP_LABELS: Partial<Record<FunnelStep, string>> = {
  Created: 'Claimed',
  'Closing Scheduled': 'CTC'
};
export function ThroughputFunnel({
  metrics
}: ThroughputFunnelProps) {
  const keyMetrics = metrics.filter(m => KEY_STEPS.includes(m.step));
  return <Card className="mb-8 p-0 overflow-hidden" noPadding data-id="element-135">
      <CardHeader bordered className="!mb-0" data-id="element-136">
        <CardTitle data-id="element-137">Conversion Funnel</CardTitle>
      </CardHeader>

      <div className="px-6 py-8" data-id="element-138">
        <div className="flex items-stretch justify-between" data-id="element-139">
          {keyMetrics.map((metric, index) => {
          const isLast = index === keyMetrics.length - 1;
          const isFirst = index === 0;
          const nextMetric = !isLast ? keyMetrics[index + 1] : null;
          const stepConversion = nextMetric && metric.count > 0 ? (nextMetric.count / metric.count * 100).toFixed(0) : '0';
          const label = STEP_LABELS[metric.step] || metric.step;
          return <Fragment key={metric.step} data-id="element-140">
                <div className="flex flex-col items-center text-center flex-1 min-w-0" data-id="element-141">
                  <div className="text-xs font-medium uppercase tracking-wide text-[#706E6B] mb-2" data-id="element-142">
                    {label}
                  </div>
                  <div className="text-2xl font-semibold tabular-nums text-[#181818] mb-1" data-id="element-143">
                    {metric.count.toLocaleString()}
                  </div>
                  <div className="text-xs tabular-nums text-[#706E6B]" data-id="element-144">
                    {isFirst ? '\u00A0' : `${metric.overallConversionRate.toFixed(1)}% of total`}
                  </div>
                </div>

                {!isLast && <div className="flex flex-col items-center justify-center px-2 shrink-0" data-id="element-145">
                    <ChevronRight className="h-4 w-4 text-[#CCCCCC]" data-id="element-146" />
                    <span className="text-[10px] font-medium tabular-nums text-[#706E6B] mt-0.5" data-id="element-147">
                      {stepConversion}%
                    </span>
                  </div>}
              </Fragment>;
        })}
        </div>
      </div>
    </Card>;
}